import(/* webpackMode: "eager" */ "/home/runner/work/snep-land/snep-land/app/photos/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Over18Confirmation"] */ "/home/runner/work/snep-land/snep-land/Components/Over18Confirmation/Over18Confirmation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhotoViewer"] */ "/home/runner/work/snep-land/snep-land/Components/PhotoViewer/index.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/snep-land/snep-land/Components/StyledLink/style.module.css");
;
import(/* webpackMode: "eager" */ "/home/runner/work/snep-land/snep-land/Components/Title/style.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/snep-land/snep-land/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/snep-land/snep-land/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/snep-land/snep-land/node_modules/react-photo-view/dist/react-photo-view.css");
